export const ALLOWED_FMLM_COUNTRY_CODE = ["AE", "UAE"]; // Must be in capital

export const SUPPORTED_LOCALES = ['en', 'ar'] as const;
export const DEFAULT_LOCALE = 'en';

export const ISO_FULL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const ISO_FULL_DATE_FORMAT_NO_TZ = 'YYYY-MM-DDTHH:mm:ss';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_24H_FORMAT = "HH:mm";
export const TIME_12H_FORMAT = "hh:mm A";

export const DEFAULT_TIMEZONE = "Asia/Dubai";
export const UTC_TIMEZONE = "Etc/UTC";

export const MOBILE_CODE_DEFAULT = "+971";

export const PASSENGER_WITH_BIRTHDATE_TYPES = ["seniorcitizens", "children", "infants"];
